import type {
  ClientGeoArea,
  ClientOrganization
} from '@DigitaleDoerfer/digitale-doerfer-api';

import { useGetGeoArea } from '@/features/api/hooks/participant-geo-area/useGetGeoArea';

/**
 * Resolves an organization's primary region: the first entry in the org's
 * geoAreaIds list, plus the full GeoArea object (name, center, bounds…).
 *
 * All fields can be undefined while loading or when the organization has no
 * geo areas assigned.
 */
export const useOrganizationRegionName = (
  organization?: ClientOrganization
): {
  regionGeoAreaId?: string;
  regionName?: string;
  regionGeoArea?: ClientGeoArea;
} => {
  const regionGeoAreaId = organization?.geoAreaIds?.[0] ?? undefined;
  const { data: regionGeoArea } = useGetGeoArea(regionGeoAreaId);
  return {
    regionGeoAreaId,
    regionName: regionGeoArea?.name,
    regionGeoArea
  };
};
